<div>
    <button
        mat-icon-button
        matTooltip="Expand all"
        [attr.data-uiid]="dataUiid + '-expand-all'"
        (click)="expandAll()"
    >
        <mat-icon>add</mat-icon>
    </button>
    <button
        mat-icon-button
        matTooltip="Expand to selected"
        [attr.data-uiid]="dataUiid + '-expand-selected'"
        (click)="expandSelected()"
    >
        <mat-icon>done</mat-icon>
    </button>
    <button
        mat-icon-button
        matTooltip="Collapse all"
        [attr.data-uiid]="dataUiid + '-collapse-all'"
        (click)="collapseAll()"
    >
        <mat-icon>remove</mat-icon>
    </button>
    <mat-divider [vertical]="true" style="display: inline"></mat-divider>
    @if (multiple) {
        <button
            mat-icon-button
            matTooltip="Select all"
            [attr.data-uiid]="dataUiid + '-select-all'"
            (click)="selectAll(true)"
        >
            <mat-icon>done_all</mat-icon>
        </button>
    }
    <button
        mat-icon-button
        matTooltip="Deselect all"
        [attr.data-uiid]="dataUiid + '-deselect-all'"
        (click)="selectAll(false)"
    >
        <mat-icon>close</mat-icon>
    </button>
    <mat-divider [vertical]="true" style="display: inline"></mat-divider>
    @if (multiple) {
        <mat-checkbox
            [checked]="includeChildren"
            [attr.data-uiid]="dataUiid + '-include-children-checkbox'"
            (change)="toggleIncludeChildren()"
            >Include children</mat-checkbox
        >
    }
    <mat-form-field>
        <mat-label>Search / Filter</mat-label>
        <input
            matInput
            type="text"
            [ngModel]="filterValue"
            [attr.data-uiid]="dataUiid + '-filter-input'"
            (input)="filterChanged($event)"
        />
        @if (filterValue) {
            <button
                matSuffix
                mat-icon-button
                [attr.data-uiid]="dataUiid + '-filter'"
                (click)="filterChanged()"
            >
                <mat-icon>close</mat-icon>
            </button>
        }
    </mat-form-field>
</div>

<mat-divider></mat-divider>

@if (multiple) {
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodePadding
            [style.display]="node.hidden ? 'none' : 'flex'"
        >
            <button mat-icon-button disabled></button>
            <mat-checkbox
                [checked]="node.selected"
                [indeterminate]="!node.selected && node.childSelected"
                [attr.data-uiid]="dataUiid + '-parent-node-' + node.id"
                (change)="multiSelectChange(node)"
                ><span [style.fontWeight]="node.highlighted ? 'bold' : 'normal'">{{
                    node.name
                }}</span></mat-checkbox
            >
        </mat-tree-node>

        <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            [style.display]="node.hidden ? 'none' : 'flex'"
        >
            <button mat-icon-button matTreeNodeToggle>
                <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                </mat-icon>
            </button>
            <mat-checkbox
                [checked]="node.selected"
                [indeterminate]="!node.selected && node.childSelected"
                [attr.data-uiid]="dataUiid + '-child-node-' + node.id"
                (change)="multiSelectChange(node)"
                ><span [style.fontWeight]="node.highlighted ? 'bold' : 'normal'">{{
                    node.name
                }}</span></mat-checkbox
            >
        </mat-tree-node>
    </mat-tree>
} @else {
    <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node
            *matTreeNodeDef="let node"
            matTreeNodePadding
            [style.display]="node.hidden ? 'none' : 'flex'"
        >
            <button mat-icon-button disabled></button>
            <mat-radio-button
                [checked]="node.selected"
                [attr.data-uiid]="dataUiid + '-parent-node-' + node.id"
                (change)="singleSelectChange(node)"
                ><span [style.fontWeight]="node.highlighted ? 'bold' : 'normal'">{{
                    node.name
                }}</span></mat-radio-button
            >
        </mat-tree-node>

        <mat-tree-node
            *matTreeNodeDef="let node; when: hasChild"
            matTreeNodePadding
            [style.display]="node.hidden ? 'none' : 'flex'"
        >
            <button mat-icon-button matTreeNodeToggle>
                <mat-icon class="mat-icon-rtl-mirror">
                    {{ treeControl.isExpanded(node) ? "expand_more" : "chevron_right" }}
                </mat-icon>
            </button>

            <mat-radio-button
                [checked]="node.selected"
                [attr.data-uiid]="dataUiid + '-child-node-' + node.id"
                (change)="singleSelectChange(node)"
                ><span [style.fontWeight]="node.highlighted ? 'bold' : 'normal'">{{
                    node.name
                }}</span></mat-radio-button
            >
        </mat-tree-node>
    </mat-tree>
}
